import { Row, Col } from "react-bootstrap";
import { SEVERITY } from "../../constants"
import { IIncidentDetails } from '../../helpers/incidentHelper';
import { isEmpty, findIndex } from 'lodash';

const IncidentCard = ({currentIncident, incidents, carouselMode = false, setCurrentIIncident, onClick}:
	{currentIncident?:IIncidentDetails, incidents?:[IIncidentDetails], carouselMode?:boolean, setCurrentIIncident?:(any)=>void, onClick?:(any)=>void}) => {

	var background = "bg-primary"
	var iconClass = "bi-exclamation-octagon-fill"
	var color = "white"

	if (currentIncident === undefined) {
		return <div />
	}

	const currentIndex = findIndex(incidents, inc => inc.name === currentIncident?.name)

	var isFirst = false;
	var isLast = false

	if (!isEmpty(incidents)) {
		isFirst = currentIndex === 0
		isLast =  currentIndex === (incidents!.length - 1) 
	}
	
	if(currentIncident) {
		switch (currentIncident.severity) {
			case SEVERITY.CRITICAL:
				background = "bg-danger"
				break;
			case SEVERITY.WARNING:
				background = "bg-warning"  
				color = "black"
				iconClass = "bi-exclamation-triangle-fill"
				break;
			case  SEVERITY.GOOD:
				background = "bg-success" 
				iconClass = "bi-hand-thumbs-up-fill"
				break;
			case  SEVERITY.NOT_SCORABLE:
			case  SEVERITY.UNKNOWN:		
				background = "bg-success" 
				iconClass = "bi-hand-thumbs-up-fill"
				break;
			default:
				break;
		}
	}

	function navigateRight(e) {
		if (incidents) {
			const newIndex = currentIndex + 1
			if (newIndex < incidents.length) {
				setCurrentIIncident && setCurrentIIncident(incidents[newIndex])
			}
			
		}
	}

	function navigateLeft(e) {
		if (incidents) {
			const newIndex = currentIndex - 1
			if (newIndex > -1) {
				setCurrentIIncident && setCurrentIIncident(incidents[newIndex])
			}
		}
	}

	const showLeftArrow = (!isFirst && onClick === undefined)
	const showRightArrow = ( onClick !== undefined || !isLast)

	const auxillaryStyle = {alignSelf:'center', marginLeft:'auto', marginRight:'auto'}
	const iconStyle = { width:`${carouselMode ? '65px' : '55px'}`, marginLeft: `${carouselMode ? '0px' : '15px'}` ,color: color, marginRight: "0.65rem",alignSelf:'center',display:'flex', justifyContent:'center', borderRadius: "0.25rem"}
	const arrowStyle = {alignSelf:'center', display:'flex', justifyContent:'center', alignItems:'center'}

	return (
		<div className="card tile w-100" onClick={ onClick } style={{paddingTop:10, paddingBottom:10}}>
			<Row className="g-0 align-items-center">
				{ carouselMode && (
					<Col xs="auto">
						<div onClick={showLeftArrow ? navigateLeft : () => {}} style={{ width:"40px", display:'flex'}} data-testid="left-arrow-container">
							<i className={showLeftArrow ? "fa-solid fa-chevron-left fs-7 mt-0" : ""} style={auxillaryStyle}></i>
						</div>
					</Col>
				)}
				<Col xs="auto">
					<div className={`${background}`} style={iconStyle}> <i className={`bi ${iconClass} fa-2x`}></i> </div>
				</Col>
				<Col>
					<div className="app-page-text">
						<div className="fs-5 mb-sm-0" >{`${currentIncident?.name}`}</div>
						{currentIncident?.details && (
							<div className="fs-6 mt-sm-0" style={{marginTop: -5 }}>{currentIncident.details}</div>
						)}
					</div>
				</Col>
				<Col xs="auto">
					<div onClick={showRightArrow ? navigateRight : () => {}} style={{ width:50, height:50, ...arrowStyle}} data-testid="right-arrow-container">
						<i className={showRightArrow ? "fa-solid fa-chevron-right fs-7 mt-0" : ""}></i>
					</div>
				</Col>
			</Row>
		</div>	
		
	)	
}

export default IncidentCard;